/*https://www.npmjs.com/package/js-carousel*/
import jscarousel from 'js-carousel'

const jQuery = require( "jquery" )
window.$ = jQuery
window.jQuery = jQuery

import './bootstrap_parts';

// https://kladr-api.ru/
require( './fias_core' )
require( './fias' )
require( './fias_zip' )

import './pay'
